import React, { useState } from "react";
import { chatBubbleIcon, bellIconBlue, CloseCircular } from "../../assets/images";
import Button from "../button";
import "./index.scss";

// Ported from ExchangeFE. Shows a small fixed-position card prompting the user
// to allow browser notifications. Dismissal is sticky via localStorage so the
// prompt does not re-appear once the user has acted on it.
const DISMISSED_KEY = "chatNotificationAlertDismissed";

const ChatNotificationAlert = () => {
  const [visible, setVisible] = useState(() => {
    if (!("Notification" in window)) return false;

    const wasDismissed = localStorage.getItem(DISMISSED_KEY) === "true";
    const permissionPending = Notification.permission === "default";

    return !wasDismissed && permissionPending;
  });

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "true");
    setVisible(false);
  };

  const handleAllowNotifications = async () => {
    if ("Notification" in window) {
      await Notification.requestPermission();
    }
    dismiss();
  };

  if (!visible) return null;

  return (
    <div className="chatNotificationAlert">
      <div className="chatNotificationAlertHeader">
        <div className="chatNotificationAlertIconWrap">
          <img
            src={chatBubbleIcon}
            alt="chat"
            className="chatNotificationAlertChatIcon"
          />
          <img
            src={bellIconBlue}
            alt="notifications"
            className="chatNotificationAlertBellIcon"
          />
        </div>
        <img
          src={CloseCircular}
          alt="close"
          className="chatNotificationAlertClose"
          onClick={dismiss}
        />
      </div>
      <div className="chatNotificationAlertBody">
        <p className="font18Black boldFont chatNotificationAlertTitle">
          New Messaging System
        </p>
        <p className="chatNotificationAlertText">
          The TTA Chat is here! By allowing browser
          notifications, you can stay up to date in your conversations.
        </p>
      </div>
      <div className="chatNotificationAlertFooter">
        <Button
          label="Allow Notifications"
          type="btn"
          className="btn-blue chatNotificationAlertBtn"
          onClick={handleAllowNotifications}
        />
      </div>
    </div>
  );
};

export default ChatNotificationAlert;
